module.exports = "<div>\n\t<div class=\"severity-wrapper \">\n\t\t<div class=\"status-name\">\n\t\t\t<i class=\"icon {{$ctrl.severityClass}}\"></i>\n\t\t\t{{$ctrl.capitalStatus}}\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/modules/distribution/components/xrayServerityStatus/xray.status.view.html
// module id = 495
// module chunks = 6